import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageDFB2 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Will Selina Cerci Move to Wolfsburg",
            author: "footballgirl",
               date: "March 5, 2026",
            image: "images/dfb/2a.jpg",
           content: `<p>After her national-team withdrawal due to injury, TSG Hoffenheim forward Selina Cerci is rumoured to be joining VfL Wolfsburg. This would follow teammate Giovanna Hoffmann’s confirmed move and further bolster 
           Wolfsburg’s forward line in 
           the Frauen-Bundesliga.</p>`,
           tags: ["Wolfsburg", "dfb", "Selina Cerci"],
           navIndices: { prev: 'dfb-1', next: 'dfb-3' }
        });
    }

    init() {
        console.log('ArticlePageDFB2 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to DFB
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'dfb' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_dfb.png';
            leagueLogo.alt = 'DFB';
        }
    }
}